import React from "react";

import {
  Heading,
  Flex,
  Box,
  Text,
  useMatchBreakpoints,
} from "@edricphan2022/uikit";
import Container from "../../components/Container";
import ContentHeader from "../../components/ContentHeader";
import FlexLayout from "../../components/LayoutFlex";
import Picture from "../../components/Picture";
import SliderOrbit from "../../components/SliderOrbit";
import CarouselCase from "./CarouselCase";
import OurChangess from "./OurChange";
import OurTeam from "../HomeOrbit/OurTeams";
import styled from "styled-components";
import AboutBg from "../../assets/About/Backgroundbackground3.png";
import IconFe1 from "../../assets/About/FeIcon1.svg";
import IconFe2 from "../../assets/About/FeIcon2.svg";
import IconFe3 from "../../assets/About/FeIcon3.svg";
import IconBe1 from "../../assets/About/BeIcon1.svg";
import IconBe2 from "../../assets/About/BeIcon2.svg";
import IconBe3 from "../../assets/About/BeIcon3.svg";
import Panner from "../../assets/About/pannerAbout.svg";

import { Wrapper, OurChange } from "./styled";
import InfomationBanner from "../HomeOrbit/InfomationBanner";
import MajorDev from "./MajorDev";

const ArrFrontEnd = {
  Major: "Front-End",
  des: [
    {
      img: IconFe1,
      text: "Our team of it experts with long-term experience in front-end development and a deep understanding of website user usage behavior has constantly improved and upgraded to bring the best experiences for clients.",
    },
    {
      img: IconFe2,
      text: "Our experts also knowledgeable about search engine optimization (SEO) and SEMs and also about how to interact with Interface designs. ",
    },
    {
      img: IconFe3,
      text: "Also, we repeatedly update the latest technologies into each project whether simple or complex to create the most convenient and eye-catching products.",
    },
  ],
};
const ArrBackEnd = {
  Major: "Back-End",
  des: [
    {
      img: IconBe1,
      text: "We offer Back-end solutions that allow you to extend your web applications and some other services. Our IT talents are also willing to support you in integrating your existing legacy systems despite the different origins.",
    },
    {
      img: IconBe2,
      text: "Besides, Wikex Exchange helps your business migrate back-end systems to cloud storage to optimize your productivity and scalability in the future.",
    },
    {
      img: IconBe3,
      text: "Our tech stack: PHP, Java, Python, С#, JavaScript",
    },
  ],
};

const HomeDetail = () => {
  const { isTabletS, isDesktop } = useMatchBreakpoints();

  return (
    <Wrapper as="section">
      <HeadeaAbout>
        <HeadeaAboutContent>
          <HeadeaAboutTitle>
            <h4>Who we are?</h4>
            <h3>About Us</h3>
          </HeadeaAboutTitle>
          <HeadeaAboutText>
            <p>
              Orbit Technology have developed products for 70+ companies in
              these industries.
              <br /> The more experienced, the better applications built.
            </p>
          </HeadeaAboutText>
        </HeadeaAboutContent>
      </HeadeaAbout>
      <PannerContainer>
        <PannerText>
          <h1>NEW GENERATION OF BLOCKCHAIN DEVELOPMENT</h1>
          <p>
            Our core values are transparency, expertise and creativity. We are
            part of the client’s team, sharing our values and strive to provide
            the best results.
          </p>
        </PannerText>
        <PannerImg></PannerImg>
      </PannerContainer>
      <OurExperience>
        <OurExperienceTitles>
          <h1>Our Experience</h1>
          <p>The more experienced, the better applications built.</p>
        </OurExperienceTitles>
        <OurExperienceBox>
          <OurExperienceBoxTitle>
            <h1>Data Sience</h1>
            <p>80%</p>
          </OurExperienceBoxTitle>

          <OurExperienceBoxvalue vl={80}/>

        </OurExperienceBox>
        <OurExperienceBox>
          <OurExperienceBoxTitle>
            <h1>Front End</h1>
            <p>90%</p>
          </OurExperienceBoxTitle>

          <OurExperienceBoxvalue vl={90}/>

        </OurExperienceBox>
        <OurExperienceBox>
          <OurExperienceBoxTitle>
            <h1>Webflow</h1>
            <p>76%</p>
          </OurExperienceBoxTitle>

          <OurExperienceBoxvalue vl={76}/>

        </OurExperienceBox>
        <OurExperienceBox>
          <OurExperienceBoxTitle>
            <h1>Back End</h1>
            <p>85%</p>
          </OurExperienceBoxTitle>
          
          <OurExperienceBoxvalue vl={85}/>

        </OurExperienceBox>
        <OurExperienceBox>
          <OurExperienceBoxTitle>
            <h1>Blockchain</h1>
            <p>78%</p>
          </OurExperienceBoxTitle>

          <OurExperienceBoxvalue vl={78}/>

        </OurExperienceBox>
      </OurExperience>
      <Container>
        <MajorDev Data={ArrFrontEnd} />
        <MajorDev Data={ArrBackEnd} />
      </Container>
      <OurChange>
        <Container>
          <OurChangess />
        </Container>
      </OurChange>
    </Wrapper>
  );
};

const HeadeaAbout = styled(Box)`
  width: 100%;
  position: relative;
  background-image: url("/assets/about/BannerAbout.svg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 40px 0px 55px 0px;
  background-color: #333333;
  :after {
    content: "";
    background-image: url("/assets/about/bannerAboutV2.svg");
    aspect-ratio: 212/182;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
  @media only screen and (max-width: 1133px) {
    padding: 19px 0px;
  }
  @media only screen and (max-width: 744px) {
    :after {
      background-image: url("${Panner}");
      height: 40%;
      top: 45%;
    }
  }
`;
const HeadeaAboutContent = styled(Box)`
  width: 100%;
  max-width: 1920px;
  padding: 0px 5.4vw;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  @media only screen and (max-width: 1280px) {
    padding: 0px 36px;
  }
  @media only screen and (max-width: 820px) {
    padding: 0px 12px;
  }
  @media only screen and (max-width: 744px) {
    flex-direction: column;
  }
`;
const HeadeaAboutTitle = styled(Box)`
  min-width: 221px;
  h3,
  h4 {
    color: #ffffff;
  }
  h4 {
    font-size: 30px;
    font-weight: 400;
    font-family: ManropeRegular;
  }
  h3 {
    font-size: 48px;
    font-family: ManropeBold;
    font-weight: 700;
  }
  @media only screen and (max-width: 1132px) {
    h4 {
      font-size: 24px;
    }
    h3 {
      font-size: 40px;
    }
  }
  @media only screen and (max-width: 744px) {
    flex-direction: column;
    width: 100%;
  }
`;
const HeadeaAboutText = styled(Box)`
  margin-left: 50px;
  p {
    font-size: 20px;
    line-height: 36px;
    font-weight: 700;
    color: white;
    font-family: ManropeBold;
  }
  @media only screen and (max-width: 1132px) {
    margin-left: 4.4vw;
  }
  @media only screen and (max-width: 744px) {
    margin-left: 0px;
    margin-top: 34px;
    p {
      font-size: 16px;
    }
  }
`;

const PannerContainer = styled(Box)`
  width: 100%;
  max-width: 1920px;
  padding: 0px 5.4vw;
  padding-top: 36px;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 1280px) {
    padding: 30px 36px 0px;
  }
  @media only screen and (max-width: 820px) {
    padding: 30px 16px 0px;
  }
  @media only screen and (max-width: 743px) {
    flex-direction: column-reverse;
  }
`;
const PannerText = styled(Box)`
  width: 49.5%;
  h1 {
    font-size: 40px;
    color: #333333;
    font-family: ManropeBold;
    line-height: 48px;
    font-weight: 700;
    max-width: 602px;
  }
  p {
    font-size: 20px;
    color: #666666;
    line-height: 22px;
    font-weight: 400;
    font-family: ManropeRegular;
    margin-top: 20px;
    max-width: 689px;
  }
  @media only screen and (max-width: 1279) {
    h1 {
      font-size: 36px;
    }
  }
  @media only screen and (max-width: 1132px) {
    h1 {
      font-size: 3.22vw;
      line-height: 36px;
    }
    p {
      margin-top: 5px;
      font-size: 16px;
    }
  }
  @media only screen and (max-width: 743px) {
    width: 100%;
    padding-top: 24px;
    h1 {
      max-width: 400px;
      font-size: 24px;
    }
  }
`;
const PannerImg = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: 49.5%;
  max-width: 830px;
  background-image: url("${AboutBg}");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 260px;
  border-radius: 8px;
  @media only screen and (max-width: 743px) {
    width: 100%;
  }
`;
const OurExperience = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 70px 5.4vw 0px;
  @media only screen and (max-width: 1280px){
    padding: 40px 32px 0px;
  }
  
  @media only screen and (max-width: 1280px){
    padding: 24px 32px 0px;
  }
  
  @media only screen and (max-width: 820px){
    padding: 24px 16px 0px;
  }
`;

const OurExperienceTitles = styled(Box)`
  width: 49.5%;
  h1 {
    font-size: 40px;
    color: #333333;
    font-family: ManropeBold;
    line-height: 60px;
    font-weight: 700;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    font-family: ManropeRegular;
    color: #333333;
    font-weight: 400;
  }
  @media only screen and (max-width: 743px){
    width: 100%;
  }
`;
const OurExperienceBox = styled(Box)`
  width: 49.5%;
  border-radius: 8px;
  background-color: #fefdf5;
  padding: 24px 40px;
  box-shadow: 0px 40px 120px #E6E3D3;
  margin-bottom: 24px;
  :hover {
    background-color: #ffffff;
  }

  @media only screen and (max-width: 1440px){
    padding: 24px 30px;
  }

  @media only screen and (max-width: 1280px){
    padding: 24px 28px;
  }

  @media only screen and (max-width: 1280px){
    padding: 24px 16px;
  }

  @media only screen and (max-width: 743px){
    width: 100%;
    margin-bottom: 12px;
  }
`;
const OurExperienceBoxTitle = styled(Box)`
  display: flex;
  justify-content: space-between;
  h1,
  p {
    color: #333333;
    font-family: ManropeBold;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }
`;
const OurExperienceBoxvalue = styled(Box)<{vl?:number}>`
  width: 100%;
  height: 16px;
  background-color: #ffffff;
  border-radius: 8px;
  margin-top: 16px;
  position: relative;
  :before {
    content:"";
    top: 0px;
    left: 0px;
    width: ${({vl})=>vl}%;
    height: 100%;
    background-color: #F7DA57;
    border-radius: 8px;
    position: absolute;
  }
`

export default HomeDetail;
